import { useNavigate } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { Button } from 'src/shared/components/ui/buttons/button'
import { ProgressBar } from 'src/shared/components/ui/progress-bar'

import { useUserById } from '../../../api/accounts/use-user-by-id'
import { useUserReviews } from '../../../api/marketplace/use-user-reviews'
import { ReviewStar } from '../../../assets/review-star'
import NoReviews from '../empty/no-reviews'

import PublicPageReviewCard from './public-page-review-card'
import ReviewNumber from './review-number'

export default function ReviewSection({ userId, username }: { userId: number; username: string }) {
  const navigate = useNavigate()
  const { data: user } = useUserById(userId)
  const { data } = useUserReviews(userId)

  // const reviewStatus = useMemo(() => {
  //   return data?.totalReviews ? (
  //     <div className="flex items-center justify-center gap-1.5 text-xs font-semibold text-muted lg:gap-2 lg:text-[14px]">
  //       <ReviewStar size={13} pattern="gold" />
  //       <span>{(data?.averageRating || 0).toFixed(1)}</span>
  //       <span className="align-middle text-xs" style={{ fontSize: '10px', lineHeight: '1' }}>
  //         •
  //       </span>
  //       <span>
  //         {data?.totalReviews || 0} review{data?.totalReviews === 1 ? '' : 's'}
  //       </span>
  //     </div>
  //   ) : (
  //     <div className="text-sm font-semibold italic text-muted lg:text-base">No reviews</div>
  //   )
  // }, [data])

  const showAllButtonOnClick = () => {
    navigate(paths.users.publicProfile.reviews.getHref(username))
  }

  const hasMoreReviews = (data?.reviews?.length || 0) > 3
  const reviews = data?.reviews?.slice(0, 3) || []
  const reviewPercentage = [
    { percentage: 95, label: '5' },
    { percentage: 3, label: '4' },
    { percentage: 2, label: '3' },
    { percentage: 0, label: '2' },
    { percentage: 0, label: '1' },
  ]

  if (reviews.length === 0) {
    return (
      <div className="flex flex-row justify-between gap-[50px] md:flex-col lg:gap-[80px]">
        <NoReviews firstName={user?.firstName || ''} />
      </div>
    )
  }

  return (
    <div className="flex flex-col justify-between gap-[50px] md:flex-row lg:gap-[80px]">
      <div>
        <div className="mb-7 text-[18px] font-semibold leading-none tracking-[-0.24px] text-primary xs:text-[24px] md:mb-5">
          Reviews
        </div>
        <ReviewNumber rating={data?.averageRating || 0} />
        <div className="mt-[18px] flex flex-col gap-2">
          {reviewPercentage.map((percentage, index) => (
            <div key={index} className="flex flex-row items-center gap-3">
              <span className="flex flex-row items-center gap-[3px]">
                {percentage.label}
                <ReviewStar size={13} pattern="full_black" />
              </span>
              <ProgressBar
                value={percentage.percentage}
                className="h-[4px] w-full bg-[#F8F7F5] xs:w-[220px]"
                color="bg-primary"
              />
            </div>
          ))}
        </div>
      </div>
      <div className="flex w-full min-w-0 flex-col gap-6 xs:gap-8">
        {reviews.map((review, index) => (
          <>
            <PublicPageReviewCard key={`${review.serviceDescription}-${review.date}`} review={review} type="section" />
            {index !== reviews.length - 1 && <div className="mb-px mt-1 h-px w-full bg-[#E5E5E5] xs:mt-4" />}
          </>
        ))}
        {hasMoreReviews && (
          <Button
            variant="default"
            className="h-[45px] w-full rounded-full text-[14px] font-semibold xs:w-[140px]"
            onClick={showAllButtonOnClick}
          >
            Show more
          </Button>
        )}
      </div>
    </div>
  )
}
